import { render, staticRenderFns } from "./_PaxField.vue?vue&type=template&id=3e565c0a"
import script from "./_PaxField.vue?vue&type=script&lang=js"
export * from "./_PaxField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports